"use client";

import React from "react";
import { Breadcrumbs } from "@/components/layout/breadcrumbs";
import { SearchInput } from "@/components/shared/search-input";
import { NotificationBell } from "@/components/shared/notification-bell";
import { UserMenu } from "@/components/shared/user-menu";

interface WorkspaceHeaderProps {
  title?: string;
  breadcrumbs?: Array<{ label: string; href?: string }>;
}

export function WorkspaceHeader({ title, breadcrumbs }: WorkspaceHeaderProps) {
  return (
    <header className="flex h-14 items-center justify-between border-b border-border bg-card px-5 md:px-6">
      <div className="flex min-w-0 items-center gap-4">
        {title && (
          <h1 className="text-sm font-semibold tracking-tight text-foreground">
            {title}
          </h1>
        )}
        {title && breadcrumbs && breadcrumbs.length > 0 && (
          <span className="text-neutral-300" aria-hidden="true">/</span>
        )}
        {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
      </div>

      <div className="flex items-center gap-2">
        <SearchInput />
        <NotificationBell />
        <UserMenu />
      </div>
    </header>
  );
}
